// The building-detail spaces query for the PowerSync local mirror
// (use-session-detail.ts). Exported so session-spaces-order.sqlite.test.ts
// can run the EXACT statement against a real SQLite and pin its order.
//
// ORDER: pseudo (site-level) rooms first, then floor order, then the room's
// serial. Same-serial rooms exist (two field-added rooms of different types
// can share a serial), and SQLite gives ties an arbitrary, plan-dependent
// order — so the list could reorder between renders, devices, or after a
// re-sync. room_type_id then id break the tie deterministically
// (audit-1-#15, sibling of the #853 key fix). floor-section.tsx's client
// sort and the server's loadSpaces (get-session.ts) use the same keys.
export const SESSION_SPACES_SQL = `SELECT
       sp.id,
       sp.building_id,
       sp.floor_id,
       fl.name AS floor_name,
       sp.room_type_id,
       rt.name AS room_type_name,
       sp.serial_number,
       sp.display_name,
       sp.alias,
       sp.is_pseudo,
       sp.is_field_added,
       sp.requires_review
     FROM spaces sp
     INNER JOIN room_types rt ON sp.room_type_id = rt.id
     LEFT JOIN floors fl ON sp.floor_id = fl.id
     WHERE sp.building_id = ?
     ORDER BY sp.is_pseudo DESC, fl.display_order ASC, sp.serial_number ASC,
       sp.room_type_id ASC, sp.id ASC`
